import React, { useState } from 'react';
import { Drawer, Divider, Grid, Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import AppIcons from '../../assets/images/icons';
import SVGIcons from '../../assets/images/icons/svgIcons';
import { translateThis } from '../../helpers/language.helper';
import { getCurrentFacilityURL } from '../../helpers/helper.functions';
import './index.scss';
import LogoutButton from '../buttons/logout.button';


const AppDrawer = ({ drawerSwitch = false, onClose }) => {
    const [siderCollapsed, setSiderCollapsed] = useState(false);

    const facilityURL = getCurrentFacilityURL();

    const { Sider } = Layout;

    const screenBreakpoint = Grid.useBreakpoint();

    const drawerWidth = "240px";
    const collapsedWidth = "70px";


    const location = useLocation();
    // console.log(location);

    const myNavItems = [
        {
            title: translateThis("AI Dev"),
            icon: SVGIcons.AiIcon(),
            link: `/${facilityURL}/ai-development/modules`,
            key: 'ai-dev',
        },
        {
            title: translateThis("Tickets"),
            icon: SVGIcons.AiIcon(),
            link: `/${facilityURL}/ai-development/tickets`,
            key: 'tickets',
        },

    ]

    const loginMenu = [
        // {
        //     title: translateThis("profile"),
        //     icon: SVGIcons.ProfileIcon(),
        //     link: `/profile`,
        //     key: 'profile',
        // },
        {
            title: translateThis("Logout"),
            icon: SVGIcons.LogoutIcon(),
            button: `/my-portal`
        },
    ]

    const selectedKeys = myNavItems.filter((item) => {
        if (location.pathname.startsWith(item.link) && item.link !== '/' && location.pathname !== '/') {
            return true;
        }
        if (item.link === '/' && location.pathname === '/') {
            return true;
        }
        return false;
    }).map((item) => item.key);


    const menuItems = myNavItems.map((element, index) => ({
        key: element.key,
        icon: element.icon,
        label: <Link key={index} className={(location.pathname) === element.link ? 'active' : ''} to={element.link} onClick={onClose}>{element.title}</Link>,
    }));
    const loginMenuItems = loginMenu.map((element, index) => ({
        key: element.key,
        icon: element.icon,
        label: <>{element.link ? <Link key={index} to={element.link} onClick={onClose}>{element.title}</Link> : null}
            {element.button ? <span key={index} onClick={onClose} role="button" tabIndex={0}><LogoutButton /></span> : null}</>,
    }));

    const LogoBox = () => {
        return (
            <div className="logo">
                <img className="main-logo" src={AppIcons.logo} alt={'Pnp Logo'} />
                <img className="sm-logo" src={AppIcons.smLogo} alt={'Pnp Logo'} />
            </div>
        )
    }



    return (
        <>
            {screenBreakpoint.lg ? <Sider
                className='slider-menu-wrp'
                collapsible
                width={drawerWidth}
                collapsedWidth={collapsedWidth}
                collapsed={siderCollapsed}
                onCollapse={(value) => setSiderCollapsed(value)}
                style={{
                    paddingBottom: '0',
                    background: 'var(--bodyBG)',
                }}
            >
                <LogoBox />
                <div className='side-menu-wrp'>
                    <div className='main-menu'>
                        <Menu className="list-menu_1" style={{ background: 'var(--bodyBG)' }} selectedKeys={selectedKeys} mode="inline" items={menuItems} />
                    </div>
                    <div className="sider-footer" style={{ color: '#fff' }} >
                        <Divider style={{ margin: '10px 0' }} />
                        <Menu className="list-menu_2" style={{ background: 'var(--bodyBG)' }} mode="inline" items={loginMenuItems} />
                    </div>
                </div>
            </Sider> : <Drawer
                title={<LogoBox />}
                className='slider-menu-wrp'
                placement="left"
                closable
                onClose={onClose}
                open={drawerSwitch}
                width='250px'
            >
                <div className='side-menu-wrp'>
                    <div className='main-menu'>
                        <Menu className="list-menu_1" selectedKeys={selectedKeys} mode="inline" items={menuItems} />
                    </div>
                    <div className="sider-footer" style={{ color: '#fff' }} >
                        <Divider style={{ margin: '10px 0' }} />
                        <Menu className="list-menu_2" mode="inline" items={loginMenuItems} />

                    </div>
                </div>
            </Drawer>}

        </>
    );
};

export default AppDrawer;